const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
  return localStorage.getItem("token");
}

async function request(endpoint, { method = "GET", body, auth = true, token: tokenOverride } = {}) {
  const headers = {};

  if (auth) {
    const token = tokenOverride || getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }

  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
  }

  return fetch(`${BASE_URL}${endpoint}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
}

const apiClient = {
  get: (endpoint, opts = {}) =>
    request(endpoint, { ...opts, method: "GET" }),

  post: (endpoint, body, opts = {}) =>
    request(endpoint, { ...opts, method: "POST", body }),

  patch: (endpoint, body, opts = {}) =>
    request(endpoint, { ...opts, method: "PATCH", body }),

  delete: (endpoint, body, opts = {}) =>
    request(endpoint, { ...opts, method: "DELETE", body }),
};

export default apiClient;
